import { ISymbolData } from '../../../parseToTree.types';
import { IRemoveNotClosedTagPositionOptions } from './removeNotClosedTagPosition.types';

export const removeNotClosedTagPosition = ({
  positions,
}: IRemoveNotClosedTagPositionOptions): ISymbolData[] => {
  if (positions.length % 2 === 0) {
    return positions;
  }

  return positions.slice(0, -1);
};
